import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { ProblemSection } from "@/components/ProblemSection";
import { SolutionSection } from "@/components/SolutionSection";
import { InteractiveDemo } from "@/components/InteractiveDemo";
import { HowItWorks } from "@/components/HowItWorks";
import { ComparisonTable } from "@/components/ComparisonTable";
import { Testimonials } from "@/components/Testimonials";
import { PricingSection } from "@/components/PricingSection";
import { TrustBadges } from "@/components/TrustBadges";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { ScrollProgress } from "@/components/ScrollProgress";
import { BackToTop } from "@/components/BackToTop";
const Index = () => {
  return <div className="min-h-screen bg-background">
      <ScrollProgress />
      <Navigation />
      <main id="main" className="space-y-12 md:space-y-20 pt-20">
        <section id="hero">
          <Hero />
        </section>

        <section id="problems">
          <ProblemSection />
        </section>

        <section id="solution">
          <SolutionSection />
        </section>

        <section id="demo">
          <InteractiveDemo />
        </section>

        <section id="how-it-works">
          <HowItWorks />
        </section>

        <section id="comparison">
          <ComparisonTable />
        </section>

        <section id="testimonials">
          <Testimonials />
        </section>

        <section id="pricing">
          <PricingSection />
        </section>

        <section id="trust">
          
        </section>

        <section id="faq">
          <FAQ />
        </section>

        <section id="cta">
          <FinalCTA />
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>;
};
export default Index;